import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import axiosInstance from '../utils/axiosConfig';
import useTranslation from '../utils/useTranslation';
import Header from './Header';
import Footer from './Footer';
import { NewsFeaturedGrid } from './sections/NewsSection';

const VALID_TYPES = ['union', 'chambers'];

export default function NewsListPage() {
  const { t, lang } = useTranslation();
  const navigate = useNavigate();
  const { type: rawType } = useParams();
  const type = VALID_TYPES.includes(rawType) ? rawType : 'union';

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    axiosInstance
      .get('public/news/', { params: { lang } })
      .then((res) => {
        if (cancelled) return;
        const all = res.data?.news || [];
        const filtered = all.filter((it) =>
          type === 'chambers' ? (it.type || 'union') === 'chambers' : (it.type || 'union') !== 'chambers',
        );
        setItems(filtered);
      })
      .catch(() => {
        if (!cancelled) setItems([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [lang, type]);

  const openItem = (id) => navigate(`/news/${id}`);

  const handleNavigate = (sectionId) => {
    if (sectionId === 'home') {
      navigate('/');
      return;
    }
    if (sectionId === 'about' || sectionId === 'laws') return;
    navigate('/', { state: { scrollTo: sectionId } });
  };

  return (
    <div className="news-list-page">
      <Header active="news" onNavigate={handleNavigate} />

      <main className="container news-list-page-main">
        <header className="news-section-head">
          <h2 className="news-section-title">{t(`news_type_${type}`)}</h2>
          <p className="news-section-desc">{t('news_subtitle')}</p>
        </header>

        {loading ? (
          <div className="news-section-loading">
            <div className="spinner" />
          </div>
        ) : items.length === 0 ? (
          <p className="muted-note">{t('empty_section')}</p>
        ) : (
          <div className="news-list-page-grid">
            <NewsFeaturedGrid items={items} onOpen={openItem} t={t} lang={lang} />
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
}
